// Copyright (c) Docugami, Inc. All rights reserved.
import React, { ComponentType, FC } from 'react';
import { useDgAuth } from 'hooks/DgAuthentication';
import { useDeepLinkInitializer } from 'hooks/deepLinkInitializer';
import { Redirect } from 'react-router';

export interface WithOrgAdminRoleRequiredOptions {
  redirectIfNotAdmin?: boolean;
}

const withOrgAdminRoleRequired = <P extends object>(
  Component: ComponentType<P>,
  options: WithOrgAdminRoleRequiredOptions = {}
): FC<P> => {
  const { redirectIfNotAdmin } = options;

  return function WithOrgAdminRoleRequired(props: P): JSX.Element {
    useDeepLinkInitializer();
    const { isOrganizationAdmin } = useDgAuth();

    return isOrganizationAdmin === true ?
      <Component {...props} /> :
        redirectIfNotAdmin === true && isOrganizationAdmin === false ?
        <Redirect to={'page-not-found'} /> :
        <></>;
  };
};

export default withOrgAdminRoleRequired;
